/**
 * Hero Banner Script
 */

document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	var herobanner = document.querySelector( '.hero-banner' );

	if ( herobanner === null || herobanner === undefined ) {
		return;
	}

	var banners = document.querySelectorAll( '.hero-banner--panel' );

	var handleMouseEnter = function( e ) {
		var id = e.target.getAttribute( 'data-id' );

		[].forEach.call( banners, function( el ) {
			el.classList.remove( 'active' );
		} );

		e.target.classList.add( 'active' );
		herobanner.setAttribute( 'data-active', id );
	};

	[].forEach.call( banners, function( el ) {
		el.addEventListener( 'mouseenter', handleMouseEnter );
		el.addEventListener( 'focus', handleMouseEnter );
	} );

} );
